/**
 * Automatische Theme-Wahl: data-ui="glass" bei Touch-Geräten ((pointer: coarse))
 * ODER schmalen Fenstern (< 1024 px), sonst data-ui="wall" (PC/Desktop).
 * Reagiert auf Änderungen (matchMedia), z. B. Fenstergröße oder Tablet + Maus.
 */
export type UiTheme = 'wall' | 'glass'

const QUERY_COARSE = '(pointer: coarse)'
const QUERY_NARROW = '(max-width: 1023.98px)'

export function detectUiTheme(): UiTheme {
  if (typeof window === 'undefined' || !window.matchMedia) return 'wall'
  return window.matchMedia(QUERY_COARSE).matches || window.matchMedia(QUERY_NARROW).matches ? 'glass' : 'wall'
}

/** Setzt data-ui am <html> und hält es aktuell. Gibt eine Aufräumfunktion zurück. */
export function initUiTheme(): () => void {
  if (typeof document === 'undefined' || !window.matchMedia) return () => {}
  const apply = () => {
    const t = detectUiTheme()
    if (document.documentElement.dataset.ui !== t) document.documentElement.dataset.ui = t
  }
  apply()
  const mqs = [window.matchMedia(QUERY_COARSE), window.matchMedia(QUERY_NARROW)]
  mqs.forEach(m => (m.addEventListener ? m.addEventListener('change', apply) : m.addListener(apply)))
  return () => mqs.forEach(m => (m.removeEventListener ? m.removeEventListener('change', apply) : m.removeListener(apply)))
}
